import React from 'react';

import { ICartEntry } from 'features/cart/types';
import { calculateEntryTotalPrice } from 'features/cart/utils';

import Currency from 'components/currency';
import { getDesignToken } from 'styles/constants';

import { EntryDescriptionRow, Item, ItemHeader, ItemName, ItemPrice } from './cart-entry.styled';

const resolveEntryChildren = (
  entry: ICartEntry,
  currencyFormatter: Function
): React.ReactNode[] => {
  if (!entry.children?.length) {
    return [];
  }

  return entry.children.flatMap((child, index) => {
    if (child.children?.length) {
      return resolveEntryChildren(child, currencyFormatter);
    }

    return (
      <EntryDescriptionRow key={`${child.id}-${index}`}>
        {child.name}
        {child.price?.amount != null ? ` - ${currencyFormatter(child.price.amount)}` : ''}
      </EntryDescriptionRow>
    );
  });
};

const MinimalCartEntry = ({
  entry,
  currencyFormatter,
}: {
  entry: ICartEntry;
  currencyFormatter: Function;
}) => {
  const quantity = entry.quantity || 1;
  const amount = calculateEntryTotalPrice(entry);
  const shouldShowPrice = entry.price !== null;
  const cartEntryDescription = resolveEntryChildren(entry, currencyFormatter);

  return (
    <Item accessible focusable>
      <ItemHeader>
        <ItemName>
          {quantity > 1 && `${quantity}x `}
          {entry.name}
        </ItemName>
        <ItemPrice>
          {shouldShowPrice && (
            <Currency
              amount={amount}
              textProps={{
                ...(amount === 0 && { color: getDesignToken('icon-default') }),
                variant: 'headerFour',
                style: { margin: 0 },
                textAlign: 'right',
              }}
            />
          )}
        </ItemPrice>
      </ItemHeader>

      {cartEntryDescription}
    </Item>
  );
};

export default MinimalCartEntry;
